'use strict';

var angularModule = angular.module('t2g.common.services.geoCodeService', []);

module.exports = angularModule;

angularModule.factory('GeocodeService', function($http) {
  return {
    getGeoData: function(address, callback) {
      $http({
        method: 'GET',
        url:
          '//maps.googleapis.com/maps/api/geocode/json?address=' +
          encodeURIComponent(address) +
          '&sensor=false',
      })
        .then(function(data) {
          if (data.status == 'ZERO_RESULTS') {
            callback(data);
          }

          callback(null, data.results[0]);
        })
        .error(function(data) {
          callback(data);
        });
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/services/GeocodeService.js